/* 趙雲傳・第 4 章：箕谷（建興六年，228）
 * 史實：《趙雲傳》「明年，亮出軍，揚聲由斜谷道，曹真遣大眾當之。亮令雲與鄧芝往拒，而身攻祁山。雲、芝兵弱敵強，失利於箕谷，
 *       然斂眾固守，不至大敗。軍退，貶為鎮軍將軍。」
 *       《諸葛亮傳》「揚聲由斜谷道取郿，使趙雲、鄧芝為疑軍，據箕谷，魏大將軍曹真舉眾拒之。」
 *       注引《雲別傳》：亮曰「街亭軍退，兵將不復相錄，箕谷軍退，兵將初不相失，何故？」芝答曰「雲身自斷後，軍資什物，略無所棄，
 *       兵將無緣相失。」雲有軍資餘絹，亮使分賜將士，雲曰「軍事無利，何為有賜？其物請悉入赤岸府庫，須十月為冬賜。」亮大善之。
 *       《水經注·沔水》引諸葛亮《與兄瑾書》「前趙子龍退軍，燒壞赤崖以北閣道，緣谷百餘里。」（燒閣道不是《雲別傳》，出處另標。）
 * 流程：1. 疑軍據箕谷：曹真的大軍一波波壓上來，斂眾固守（漢兵剩不到四人就是大敗）。
 *       2. 街亭失守，全軍退：鄧芝帶輜重先走，趙雲斷後；輜重都過了閣道口，就在閣道上點火燒掉，追兵過不來。
 *       3. 赤岸：諸葛亮問話；餘絹要分賜將士，還是入赤岸府庫（走到哪一邊站定來選）。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, hero, rout } from '../kit.ts';
import { HOLD, NORTH, GE, CHIYA, CARTS, ROUTE, KU, SHANG } from '../maps/zhaoyun_jigu.ts';
import { MEN, WEI, SHU, band, npc, choose, chooseTick } from './zhaoyun_kit.ts';

const LV = 16, HOLD_T = 70, MIN_MEN = 4, BURN = [GE[0], GE[1] + 90], WALL = [GE[0], GE[1] - 110];
const CAOB = { spec: WEI, name: '曹真軍', hp: 440, maxHp: 440, atk: 20 };

export default {
  id: 'zhaoyun-4', map: 'zhaoyun_jigu', hero: 'zhaoyun',
  title: '第 6 章　箕谷', year: '建興六年（228）',
  brief: {
    quote: [{ text: '雲、芝兵弱敵強，失利於箕谷，然斂眾固守，不至大敗。', src: '《三國志·蜀書·趙雲傳》' }, { text: '雲身自斷後，軍資什物，略無所棄，兵將無緣相失。', src: '《趙雲傳》注引《雲別傳》' }],
    text: '諸葛亮第一次北伐，揚言要從斜谷取郿，派趙雲、鄧芝當疑軍據守箕谷，自己帶主力攻祁山。魏明帝派大將軍曹真督諸軍到郿。',
    goals: ['疑軍據箕谷：斂眾固守', '街亭失守：斷後，護著輜重退到閣道口', '燒閣道', '赤岸：處置餘絹'],
  },
  words: { ally: '漢兵', foe: '曹真軍' },
  stars: [
    { text: '兵將初不相失：漢兵陣亡不超過 2 人', ok: (m) => m.vars.men.filter((u) => !u.alive).length <= 2 },
    { text: '軍資什物，略無所棄：輜重一車不少', ok: (m) => m.vars.carts.every((u) => u.alive) },
    { text: '餘絹悉入赤岸府庫', ok: (m) => m.vars.choice && m.vars.choice.picked === 'ku' },
  ],
  fuel: (m, x, y) => SG.gd(x, y, WALL[0], WALL[1]) < 240, // 只燒閣道這一段
  steps: [
    { // 1. 疑軍據箕谷
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = HOLD[0]; me.y = HOLD[1] + 120;
        V.dz = ally(w, MEN.dengzhi, HOLD[0] + 160, HOLD[1] + 80, LV); V.dz.name = '鄧芝'; V.dz.hold = [HOLD[0] + 160, HOLD[1] + 80];
        V.men = band(m, me, 10, '漢兵', SHU, { hp: 750, atk: 26 });
        V.carts = Array.from({ length: 4 }, (_, i) => { const u = m.recruit(CARTS[0] - 150 + i * 100, CARTS[1] + (i % 2) * 60, '輜重'); Object.assign(u, { spec: SHU, hp: 900, maxHp: 900, atk: 0, ms: 135, noFight: true, ri: 0 }); return u; });
        V.foes = []; V.waveT = 4; V.wave = 0; V.t0 = w.t;
        m.card('先主入蜀後，雲為翊軍將軍。漢中之戰，雲大開營門、偃旗息鼓，曹軍疑有伏兵而退。先主欲伐吳，雲諫曰：「國賊是曹操，非孫權也。」先主不聽，留雲督江州。', '《趙雲傳》注引《雲別傳》');
        m.after(6, () => m.card('亮出軍，揚聲由斜谷道，曹真遣大眾當之。亮令雲與鄧芝往拒，而身攻祁山。', '《趙雲傳》'));
        m.after(10, () => m.line('鄧芝', '我們是疑軍，兵弱敵強。將軍，守得住嗎？'));
        m.after(13, () => m.line('趙雲', '不求勝，只求不亂。收攏人馬，固守谷口。'));
        m.mark('hold', HOLD[0], HOLD[1], '箕谷口', true);
        m.obj('hold', '');
      },
      tick(m, w, dt) {
        const V = m.vars, t = w.t - V.t0;
        V.waveT -= dt;
        if (V.waveT <= 0 && t < HOLD_T - 8) {
          V.waveT = 12; V.wave++;
          for (let i = 0; i < 3 + (V.wave >> 1); i++) { const u = m.foe('huangjin', NORTH[0] - 200 + (i % 5) * 100, NORTH[1] + 80 + Math.floor(i / 5) * 80, CAOB); u.home = HOLD.slice(); V.foes.push(u); }
          if (V.wave === 1) m.line('斥候', '曹真的大軍從北邊壓過來了！');
        }
        if (!V.zhen && t > 30) { V.zhen = npc(w, hero('caozhen'), NORTH[0] + 250, NORTH[1] + 80, { name: '曹真' }); m.line('曹真', '疑兵而已——壓上去！'); } // 大將軍在後督陣，不上前
        const men = V.men.filter((u) => u.alive).length;
        m.get('hold').text = `斂眾固守箕谷（還要 ${Math.max(0, Math.ceil(HOLD_T - t))} 秒；漢兵 ${men} 人，少於 ${MIN_MEN} 人就大敗）`;
        if (men < MIN_MEN) { m.lose('眾散，大敗'); return false; }
        return t >= HOLD_T;
      },
    },
    { // 2. 斷後
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('hold'); m.unmark('hold');
        m.card('雲、芝兵弱敵強，失利於箕谷，然斂眾固守，不至大敗。', '《趙雲傳》');
        m.after(4, () => m.line('鄧芝', '丞相傳令：街亭失守，全軍退回漢中！'));
        m.after(7, () => m.line('趙雲', '伯苗帶輜重和弟兄們先走。雲斷後。'));
        m.after(10, () => m.line('提示', '輜重走得慢，追兵會撲向最後一車。擋住追兵；輜重都過了閣道口，就在閣道上點火。'));
        for (const u of V.men) if (u.alive) { m.join(u, V.dz); u.noFight = true; } // 兵將隨鄧芝整隊退走，不回頭打
        V.dz.hold = null;
        V.chaseT = 6;
        m.mark('ge', GE[0], GE[1], '閣道口');
        m.obj('back', `斷後：護著輜重和弟兄們退過閣道口（漢兵少於 ${MIN_MEN} 人就大敗）`);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        const carts = V.carts.filter((u) => u.alive);
        if (!carts.length) { m.lose('軍資盡棄'); return false; }
        if (V.men.filter((u) => u.alive).length < MIN_MEN) { m.lose('兵將相失，大敗'); return false; }
        const rear = carts.reduce((a, b) => (a.y < b.y ? a : b));
        // 追兵：一波波從北口追來，撲向最後一車
        V.chaseT -= dt;
        if (!V.burnt && V.chaseT <= 0) { V.chaseT = 7; for (let i = 0; i < 5; i++) V.foes.push(m.foe('huangjin', NORTH[0] - 200 + i * 100, NORTH[1] + 100, Object.assign({}, CAOB, { ms: 265, atk: 30 }))); }
        for (const u of V.foes) if (u.alive && !u.rout && !(V.burnt && u.y < WALL[1])) u.home = [rear.x, rear.y - 60];
        const past = carts.every((u) => u.y > GE[1] + 150) && V.men.every((u) => !u.alive || u.y > GE[1] + 60);
        if (past && !V.passed) { V.passed = true; m.unmark('ge'); m.mark('burn', BURN[0], BURN[1], '燒閣道'); m.obj('burn', '輜重都過了：站在閣道口點火'); m.line('趙雲', '都過去了——燒閣道！'); }
        if (V.passed && !V.burnt) m.chanAt(me, 'burn', BURN[0], BURN[1], 170, 2.5, '燒閣道', () => {
          V.burnt = true; m.done('burn'); m.unmark('burn');
          for (let i = -2; i <= 2; i++) for (let j = 0; j < 2; j++) m.fire(WALL[0] + i * 80, WALL[1] - j * 80, { life: 1e9, dps: 60 });
          m.gate('ge', WALL[0], WALL[1] - 40, 200);
          m.big('閣道燒起來了！');
          const cut = V.foes.filter((u) => u.alive && u.y < WALL[1]);
          for (const u of cut) u.home = [u.x, NORTH[1] + 200];
          rout(m, w, cut, NORTH);
        }, { hurt: false });
        if (V.burnt && !V.toChiya) { V.toChiya = true; m.drop('back'); m.obj('chiya', '退到赤岸'); m.mark('chiya', CHIYA[0], CHIYA[1], '赤岸'); }
        return V.burnt && m.near(me, CHIYA[0], CHIYA[1], 450) && carts.every((u) => SG.gd(u.x, u.y, CHIYA[0], CHIYA[1]) < 600);
      },
    },
    { // 3. 赤岸
      enter(m, w) {
        const V = m.vars;
        m.done('chiya'); m.unmark('chiya');
        rout(m, w, V.foes, NORTH);
        V.liang = npc(w, hero('zhugeliang'), CHIYA[0], CHIYA[1] + 160, { name: '諸葛亮' });
        m.line('諸葛亮', '街亭軍退，兵將不復相錄；箕谷軍退，兵將初不相失，何故？');
        m.after(4, () => m.line('鄧芝', '雲身自斷後，軍資什物，略無所棄，兵將無緣相失。'));
        m.after(8, () => m.line('諸葛亮', '子龍還有軍資餘絹，就分賜將士吧。'));
        m.after(10, () => {
          m.line('提示', '走到「分賜將士」或「入赤岸府庫」站定來選。');
          m.obj('silk', '處置軍資餘絹');
          choose(m, w, [{ key: 'ku', label: '入赤岸府庫', x: KU[0], y: KU[1] }, { key: 'give', label: '分賜將士', x: SHANG[0], y: SHANG[1] }], (k) => {
            m.done('silk');
            if (k === 'ku') { m.line('趙雲', '軍事無利，何為有賜？其物請悉入赤岸府庫，須十月為冬賜。'); m.after(4, () => m.card('亮大善之。', '《雲別傳》（裴注）')); }
            else m.line('趙雲', '遵丞相令，分賜將士。');
            m.after(8, () => m.card('軍退，貶為鎮軍將軍。七年卒，追諡順平侯。', '《趙雲傳》'));
            m.after(13, () => m.card('當陽之役，義貫金石，忠以衛上，君念其賞，禮以厚下，臣忘其死。', '《雲別傳》載姜維等議諡'));
            m.after(18, () => m.win());
          });
        });
      },
      tick(m, w) { chooseTick(m, w); return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('趙雲陣亡'); return; }
    // 輜重：不打仗；退兵時沿著閣道一站站往南走
    for (const u of V.carts || []) {
      if (!u.alive) continue;
      u.target = null; u.think = 0.5;
      if (m.i >= 1) { const p = ROUTE[u.ri]; if (SG.gd(u.x, u.y, p[0], p[1]) < 70 && u.ri < ROUTE.length - 1) u.ri++; u.home = ROUTE[u.ri].slice(); }
    }
    if (V.dz) {
      if (m.i === 1) { const lead = V.carts.filter((u) => u.alive).sort((a, b) => b.y - a.y)[0]; V.dz.hold = lead ? [lead.x + 90, lead.y - 40] : null; }
      allyTick(w, V.dz, w.player, m.i === 1 ? 300 : 520);
    }
  },
};
